'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.FAQsCategories = void 0;
var tslib_1 = require("tslib");
var transport_1 = require("../../transport");
var slugify = function (text) {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9\u0430-\u044f]+/g, '-')
        .replace(/^-+|-+$/g, '');
};
var FAQsCategories = /** @class */ (function () {
    function FAQsCategories() {
    }
    FAQsCategories.prototype.get = function (params) {
        return (transport_1.transport
            .request('faqsCategories/get', params)
            // TODO: remove below when slug is provided by API
            .then(function (categories) {
            return categories.map(function (category) { return (tslib_1.__assign({ slug: slugify(category.title || '') }, category)); });
        }));
    };
    return FAQsCategories;
}());
exports.FAQsCategories = FAQsCategories;
